import { Button, Box } from "@mui/material";

const MyButton = ({onClick, disabled = false}) => {

  /*const onClickkk= () => {
    console.log("1 onClickOk");
  };*/


  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 1,
      }}
    >
      <Button variant="contained" color="success" onClick={onClick} disabled={disabled}>
        ENVOYER
      </Button>
    </Box>
  );
};

export default MyButton;
